/**
 * Access code registry for FORA Onboard.
 *
 * - "general" role: full portal access, no country-specific dashboard.
 * - "country_owner" role: full portal access + an extra country-specific
 *   QuickSight dashboard, gated by a private code.
 *
 * To onboard a new country in the future, add a new entry below with a unique
 * code (key) and the QuickSight embed URL prepared for that market.
 */

export const ACCESS_CODES = {
  RefreshDigital: {
    role: "general",
    country: null,
    label: "All Country Owners",
  },
  HellasDigital: {
    role: "general",
    country: null,
    label: "Hellas Team (Greece)",
  },
  ItaliaDigital: {
    role: "general",
    country: null,
    label: "Italia Team (Italy)",
    defaultLang: "it",
  },
  MKDOwner: {
    role: "country_owner",
    country: "MK",
    countryLabel: "North Macedonia",
    dashboardLabel: "Macedonia Dashboard",
    dashboardUrl:
      "https://eu-central-1.quicksight.aws.amazon.com/sn/account/franjovucic/embed/share/accounts/575108936344/dashboards/87397a56-f936-4da6-abb3-31f8adbef6e2",
  },
  ADRIAOwner: {
    role: "country_owner",
    country: "ADRIA",
    countryLabel: "Adria Region",
    dashboardLabel: "Adria Dashboard",
    dashboardUrl:
      "https://eu-central-1.quicksight.aws.amazon.com/sn/account/franjovucic/embed/share/accounts/575108936344/dashboards/efdaa200-72af-4684-9cb7-1ee535d52089",
  },
};

/** Validate an access code; returns the matching entry or null. */
export const resolveAccessCode = (code) => {
  if (!code) return null;
  return ACCESS_CODES[code] || null;
};

/** Build the country profile stored in sessionStorage. */
export const buildUserProfile = (code) => {
  const entry = resolveAccessCode(code);
  if (!entry) return null;
  return {
    code,
    role: entry.role,
    country: entry.country,
    countryLabel: entry.countryLabel || null,
    dashboardLabel: entry.dashboardLabel || null,
    dashboardUrl: entry.dashboardUrl || null,
    defaultLang: entry.defaultLang || "en",
  };
};
